import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { Paper } from '@material-ui/core';
import Box from '@material-ui/core/Box';
import Button from '@material-ui/core/Button';

import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
  outerContainer: {
    padding: '25px',
    margin: '25px',
    backgroundColor: theme.palette.outerContainer.background,
    boxShadow: '3px 3px 2px ' + theme.palette.innerContainer.shadow
  }
}));

export function Error404() {
  let { t } = useTranslation();
  const classes = useStyles();
  return (
    <Paper component={Box} className={classes.outerContainer}>
      <div
        style={{
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'center',
          alignItems: 'center'
        }}
      >
        <h2>{t('error404')}</h2>

        <Button color="secondary" to={'/'} component={Link}>
          {t('home')}
        </Button>
      </div>
    </Paper>
  );
}
